<div id="ey-navbar-container">
    <!-- <div class="d-flex align-items-center w-100 ey-logo-header">
        <a
                class="navbar-brand d-flex align-items-center me-5 text-white"
                href="index.html"
        >
            <img
                    src="assets/images/ey-logo.svg"

                    class="ey-logo-icon"
                    alt="Ey logo, lands to digital tax advisor page"
            /> </a
        >

    </div> -->
    <div id="ey-app-home" class="ey-app-home">
        <div class="ey-max-container">

            <img class="ey-bg-logo" src="assets/images/ey-bg-log-3-4.png" />
            <div id="sign-in-container" class="sign-in-container">

                <!-- <div class="admin-heading" role="heading" aria-level="1">Welcome to <br> Global E-invoicing</div>
                <div class="sub-text-container">
                    <div class="sub-text">Cloud-based application to help clients  in complying with e-invoicing requirement globally,
                        with high degree of automation; a single platform across multiple jurisdictions
                    </div>
                </div> -->

                <div  id="login-btn" class="loginButton" >

                    <button pButton type="button" class="ey-button mt-0 ey-sign-btn" (click)='redirectDashboard()'>
                        Sign In
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
